// FIELDS
import {
	SUPERUSERFIELDS_COMPASS,
	ADMINFIELDS_COMPASS,
	MANAGERFIELDS_COMPASS,
	SUPERUSERFIELDS_COMPASSCANADA,
	ADMINFIELDS_COMPASSCANADA,
	MANAGERFIELDS_COMPASSCANADA,
	ADMINFIELDS_QUAD,
	ITSHOPPERFIELDS_QUAD,
	BUYERFIELDS_QUAD,
	BASE_PRUDENTIAL,
} from "./index";

// HOOKS
import { usePrivilegeCheck, useHostName } from "../../../hooks";
// HELPERS

export const useOrdersPageViewModel = (): {
	fields: Record<string, any>;
} => {
	//get user data from
	const { isSupervisor, isAdmin } = usePrivilegeCheck();
	const { hostName } = useHostName();
	let fields;
	// Assign correct fields based on user role
	const getFieldsByHostAndPrivilege = () => {
		const fieldMapping: Record<
			string,
			{ admin?: any; superuser?: any; manager?: any; base?: any }
		> = {
			COMPASS: {
				admin: ADMINFIELDS_COMPASS,
				superuser: SUPERUSERFIELDS_COMPASS,
				manager: MANAGERFIELDS_COMPASS,
			},
			COMPASSCANADA: {
				admin: ADMINFIELDS_COMPASSCANADA,
				superuser: SUPERUSERFIELDS_COMPASSCANADA,
				manager: MANAGERFIELDS_COMPASSCANADA,
			},
			QUAD: {
				admin: ADMINFIELDS_QUAD,
				superuser: ITSHOPPERFIELDS_QUAD,
				manager: BUYERFIELDS_QUAD,
			},
			PRUDENTIAL: {
				base: BASE_PRUDENTIAL,
			},
		};

		const hostFields = fieldMapping[hostName] || fieldMapping.compass;

		if (hostName === "PRUDENTIAL") return hostFields.base;
		if (isAdmin) return hostFields.admin;
		if (isSupervisor) return hostFields.superuser;
		return hostFields?.manager;
	};

	fields = getFieldsByHostAndPrivilege();

	return {
		fields,
	};
};
